import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import API_BASE_URL from '../api';

const PetsInfo = () => {
  const [petsInfo, setPetsInfo] = useState({
    havePets: '',
    petType: '',
    petName: '',
    dateWithPets: 'Maybe',
  });

  const [showPetFields, setShowPetFields] = useState(false);
  const [message, setMessage] = useState('');
  const [isNewUser, setIsNewUser] = useState(false);

  const getAuthToken = () => localStorage.getItem('stack_access_token');
  const navigate = useNavigate();

  useEffect(() => {
    const token = getAuthToken();
    fetch(`${API_BASE_URL}/api/pets-info`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Stack-Access-Token': token,
      },
    })
      .then((response) => {
        if (response.status === 404) {
          setIsNewUser(true);
          setMessage('No pets info found. Please set your pets info.');
          return;
        }
        if (!response.ok) {
          throw new Error('Failed to fetch pets info');
        }
        return response.json();
      })
      .then((data) => {
        if (data) {
          const petsData = data.reduce((acc, item) => {
            if (item.question_text === 'Do you have any pets?')
              acc.havePets = item.answer_text;
            if (item.question_text === 'If so, what pet(s) do you have?')
              acc.petType = item.answer_text;
            if (item.question_text === 'What are/is your pets name?')
              acc.petName = item.answer_text;
            if (item.question_text === 'Would you date someone with pets?')
              acc.dateWithPets = item.answer_text;
            return acc;
          }, {});
          setPetsInfo(petsData);
          setShowPetFields(petsData.havePets === 'Yes');
        }
      })
      .catch((error) => {
        console.error('Error fetching pets info:', error);
        setMessage('Error fetching pets info.');
      });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const token = getAuthToken();

    const payload = {
      havePets: petsInfo.havePets,
      petType: petsInfo.havePets === 'Yes' ? petsInfo.petType : 'N/A',
      petName: petsInfo.havePets === 'Yes' ? petsInfo.petName : 'N/A',
      dateWithPets: petsInfo.dateWithPets,
    };

    const method = isNewUser ? 'POST' : 'PUT';

    try {
      const response = await fetch(`${API_BASE_URL}/api/pets-info`, {
        method: method,
        headers: {
          'X-Stack-Access-Token': token,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to update pets info');
      }

      setPetsInfo(payload);
      setMessage('Pets info updated successfully.');

      setTimeout(() => {
        navigate('/language-info');
      }, 2000);

      setIsNewUser(false);
    } catch (error) {
      console.error('Error setting pets info:', error);
      setMessage('Failed to update pets info.');
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setPetsInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === 'havePets') {
      setShowPetFields(value === 'Yes');
    }
  };

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{ backgroundColor: '#0D2329' }}
    >
      <Navbar />
      <div className="flex-1 flex justify-center items-center">
        <div
          className="w-full max-w-md p-8 rounded-lg shadow-md"
          style={{ backgroundColor: '#05664f' }}
        >
          <h1 className="text-4xl font-bold text-white text-center mb-6">
            Pets Info
          </h1>
          {message && (
            <p className="text-sm text-red-200 text-center mb-4">{message}</p>
          )}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="text-white">
              <label className="block text-sm font-medium">
                Do you have any pets?
              </label>
              <div className="flex space-x-4">
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="havePets"
                    value="Yes"
                    checked={petsInfo.havePets === 'Yes'}
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">Yes</span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="havePets"
                    value="No"
                    checked={petsInfo.havePets === 'No'}
                    onChange={handleChange}
                    className="form-radio"
                  />
                  <span className="ml-2">No</span>
                </label>
              </div>
            </div>

            {showPetFields && (
              <>
                <div className="text-white">
                  <label className="block text-sm font-medium">
                    If so, what pet(s) do you have?
                    <input
                      type="text"
                      name="petType"
                      value={petsInfo.petType}
                      onChange={handleChange}
                      className="mt-1 block w-full px-3 py-2 text-base border border-gray-300 text-black focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                    />
                  </label>
                </div>

                <div className="text-white">
                  <label className="block text-sm font-medium">
                    What are/is your pets name?
                    <input
                      type="text"
                      name="petName"
                      value={petsInfo.petName}
                      onChange={handleChange}
                      className="mt-1 block w-full px-3 py-2 text-base border border-gray-300 text-black focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
                    />
                  </label>
                </div>
              </>
            )}

            <div className="text-white">
              <label className="block text-sm font-medium">
                Would you date someone with pets?
              </label>
              <input
                type="range"
                name="dateWithPets"
                min="0"
                max="2"
                value={
                  petsInfo.dateWithPets === 'No'
                    ? 0
                    : petsInfo.dateWithPets === 'Maybe'
                      ? 1
                      : 2
                }
                onChange={(e) => {
                  const value = e.target.value;
                  setPetsInfo({
                    ...petsInfo,
                    dateWithPets:
                      value === '0' ? 'No' : value === '1' ? 'Maybe' : 'Yes',
                  });
                }}
                className="w-full"
              />
              <div className="flex justify-between">
                <span>No</span>
                <span>Maybe</span>
                <span>Yes</span>
              </div>
            </div>

            <button
              type="submit"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Next
            </button>

            <button
              type="button"
              className="w-full px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 mt-2"
              onClick={() => navigate('/drinking-smoking-info')} // Navigate back to the previous form
            >
              Previous
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PetsInfo;
